
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import Btn from "../../shared/button/Btn"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect } from "react"
import { showModal, showNestedModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { getBelgeDataSingleItem } from "../../../features/loadList/loadListSlice"


const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1100px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 10px 40px;
            margin: 20px 0;
            max-height: 500px;
            overflow: auto;
            width: 100%;

            h1{
                font-size: var(--font-size-lg);
                font-weight: var(--font-weight-lg);
                margin-bottom: 20px;
            }

            .doc-container{
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                display: flex;
                justify-content: center;
                gap: 40px;

                .doc-item{
                    display: flex;
                    flex-direction: column;
                    padding: 20px;
                    border-radius: 10px;

                    &:hover{
                        background-color: ${({theme}) => theme.secondaryBgColor};
                    }

                    h2{
                        font-size: var(--font-size-md);
                        font-weight: var(--font-weight-lg);
                        padding-left: 5px;
                    }

                    h3{
                        padding: 5px;
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                    }

                    img{
                        object-fit: contain;
                        border-radius: 10px;
                        width: 200px;
                        cursor: pointer;
                    }

                    p{
                        padding: 5px;
                        font-size: var(--font-size-md);
                        font-weight: var(--font-weight-lg);
                        padding-top: 10px;
                    }
                }
            }
        }

        .btn-container{
            width: 100%;
            padding: 20px;
            padding-bottom: 30px;
            display: flex;
            justify-content: center;
        }
    }
`

const ShipmentIrsaliyeModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {belgeData} = useSelector(state => state.loadList)
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <Container onClick={() => dispatch(showModal(null))}>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <div className="content">
                <h1>Sefer İrsaliyeleri</h1>
                <div className="doc-container">
                    {
                        belgeData.map((item, i) => (
                            <div className="doc-item">
                                <h2>{item.order}. {item.routeType === 0 ? "Yükleme" : "Boşaltma"} Noktası</h2>
                                <h3>{item.location}</h3>
                                <img src={`${process.env.REACT_APP_API_IMG_URI}${item.documentOfRoutePoint}`} onClick={() => {dispatch(getBelgeDataSingleItem(item)); dispatch(showNestedModal("shipmentIrsaliyeWide"))}} alt="" />
                                <p>{item.comment}</p>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className="btn-container">
                <Btn bgColor="transparent" color="#E85446" width={"260px"} handleClick={() =>dispatch(showModal(null))} borderColor="#E85446">Geri Dön</Btn>
            </div>
        </div>
    </Container>
  )
}

export default ShipmentIrsaliyeModal
